var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbonnement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EE7203;}\r\n\t.st1{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,49.2c-0.7,0-1.3,0.6-1.3,1.3v17c0,0.7,0.6,1.3,1.3,1.3h17c0.7,0,1.3-0.6,1.3-1.3v-17 c0-0.7-0.6-1.3-1.3-1.3H54z M69.7,66.1H55.3V51.7h14.5V66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.9,46.2L63,11.2c-0.6-0.5-1.4-0.5-1.9,0L21,46.1c-0.6,0.5-0.7,1.5-0.1,2.1c0.5,0.6,1.5,0.7,2.1,0.1 l8.6-7.5v46.9c0,0.8,0.7,1.5,1.5,1.5h57.4c0.8,0,1.5-0.7,1.5-1.5V39.8l10.1,8.7c0.3,0.2,0.6,0.4,1,0.4c0.4,0,0.8-0.2,1.1-0.5 C104.6,47.7,104.6,46.7,103.9,46.2z M89,86.2H34.5V38.2l27.5-24l26.9,23L89,86.2L89,86.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbonnement);
export default __webpack_public_path__ + "static/media/abonnement.3c7b47df384d226857868aab31c0782e.svg";
export { ForwardRef as ReactComponent };